import React from 'react'
import { Modal } from '@zambezi/sdk/modal'
import classNames from 'classnames'
import style from './CancelAccessModal.module.css'
import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'

export default function CancelLinkModal({ open, onCancel, onConfirm }) {
  return (
    <Modal
      className={`${modalStyle.modal} js-modal`}
      title="Cancel payment request link"
      withBackdrop
      withPadding
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      renderFooter={(onConfirm, onCancel) => (
        <div
          className={classNames(
            'zb-modal-card-foot-actions',
            style.modalFooter
          )}
        >
          <button
            className="js-confirm-action zb-button zb-button-primary zb-modal-action"
            onClick={onConfirm}
          >
            Yes, cancel payment link
          </button>
          <button
            className="zb-button-link zb-modal-action js-cancel-action"
            onClick={onCancel}
          >
            No, keep link
          </button>
        </div>
      )}
    >
      <div className={style.content}>
        Are you sure you want to delete this payment request?
      </div>
    </Modal>
  )
}
